/**
 * Talla esgotada amb reposicio: la pastilla lila obre l'avis de STOQ.
 *
 * `snippets/variant-picker.liquid` marca amb `hb-sold-notify` les talles
 * esgotades per a les quals l'app STOQ (Restock Rocket) oferira l'avis, i hi
 * pinta una pastilla lila amb una campaneta. En tocar la talla s'ha d'obrir el
 * formulari "Notificame" de l'app, directament.
 *
 * COM. L'app no te cap API publica per obrir el formulari: nomes el seu boto,
 * que CREA dins del formulari de compra quan la variant seleccionada esta
 * esgotada. Aquell boto va amagat visualment (`_forms.scss`) i aqui s'hi fa
 * clic:
 *
 *   1. el clic a la talla la selecciona, com qualsevol altra (ho fa el tema);
 *   2. s'espera que el formulari ja tingui aquesta variant a `[name="id"]` i
 *      que l'app hi hagi creat el boto;
 *   3. es clica el boto. L'app obre el seu formulari amb la variant triada.
 *
 * Verificat: `click()` sobre `.restock-rocket-button` (o sobre la capa
 * `.restock-rocket-button-cover`) obre el formulari amb la variant correcta.
 *
 * Si l'app no respon (sense xarxa, desactivada...), al cap de `TIMEOUT_MS` es
 * deixa estar: la talla queda seleccionada i el boto de compra diu "Agotado",
 * que es el comportament d'abans.
 */
(function () {
  'use strict';

  var TIMEOUT_MS = 4000;
  var STOQ_BUTTON = '.restock-rocket-button';

  var pending = null;

  /** L'input (radio) de la talla que correspon a una etiqueta. */
  function inputFor(label) {
    return label.htmlFor ? document.getElementById(label.htmlFor) : null;
  }

  /** El bloc de la fitxa on viuen el selector, el formulari i el boto de l'app. */
  function scopeOf(el) {
    return el.closest('.shopify-section') || document;
  }

  function openNotify(input) {
    var variantId = input.getAttribute('data-variant-id');
    if (!variantId) return;

    // Un sol intent viu: si se'n toca una altra, mana l'ultima.
    if (pending) clearInterval(pending);

    var scope = scopeOf(input);
    var started = Date.now();

    pending = setInterval(function () {
      var idInput = scope.querySelector('[name="id"]');
      var button = scope.querySelector(STOQ_BUTTON);

      // Esperar que el tema hagi canviat de variant i que l'app hi hagi creat
      // el boto: si no, s'obriria l'avis de la talla ANTERIOR.
      if (idInput && idInput.value === variantId && button) {
        clearInterval(pending);
        pending = null;
        button.click();
        return;
      }

      if (Date.now() - started > TIMEOUT_MS) {
        clearInterval(pending);
        pending = null;
      }
    }, 100);
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest && event.target.closest('label.opt-label--btn');
    if (!label) return;

    var input = inputFor(label);
    if (input && input.classList.contains('hb-sold-notify')) openNotify(input);
  });

  // Teclat: la talla es un radio amagat. Amb les fletxes nomes es canvia de
  // talla (obrir el formulari en passar-hi seria molest); amb Enter o espai
  // sobre la talla lila, s'obre l'avis.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var input = event.target;
    if (!input.classList || !input.classList.contains('hb-sold-notify')) return;

    event.preventDefault();
    if (!input.checked) input.click();
    openNotify(input);
  });
})();
